// Waypoint360: French locale for the DJI Pilot 2 webview (~20 user-facing strings).
// Keep keys in sync with en.ts. Other locales are seeded at the end of the DJI lots.
export default {
  attribution: {
    checking: 'Vérification du rattachement…',
    linkedTitle: 'Vol rattaché',
    linkedBody: 'Ce vol est enregistré pour {org}.',
    pendingTitle: 'Vol non rattaché',
    // Never say the flight is lost: it IS recorded. Saying otherwise would make a pilot cancel
    // a perfectly good flight.
    pendingBody: 'Aucun vol planifié pour ce drone. Le vol sera enregistré, mais non rattaché à une mission. Planifiez-le dans l\'app : le rattachement se fera tout seul.',
    pendingSeveral: 'Plusieurs vols planifiés correspondent à ce drone. Le vol sera enregistré, mais non rattaché. Précisez l\'heure de vos vols dans l\'app.',
    rejectedTitle: 'Drone non rattaché',
    rejectedBody: 'Ce drone (SN {sn}) n\'appartient à aucune flotte. Déclarez-le dans l\'app Waypoint360 pour enregistrer ses vols.',
    disconnectedTitle: 'Drone déconnecté',
    disconnectedBody: 'Aucun aéronef connecté à cette radiocommande. Allumez le drone pour enregistrer son vol.',
  },
  // Statut live poussé dans la carte de compte native DJI (la zone OpenPlatform). L'emoji porte la
  // couleur — le texte de description ne peut pas être stylé.
  marker: {
    collecting: '🟢 Collecte active',
    pending: '🟠 Rattachement en attente',
    offline: '🔴 Collecte interrompue',
  },
  boot: {
    onlyRemoteTitle: 'Accès depuis la radiocommande uniquement',
    // {app} is the (bold) "DJI Pilot 2" product name, injected via <i18n-t>.
    onlyRemoteHint: 'Cette page se lance depuis {app} sur votre radiocommande, via la plateforme cloud Waypoint360. Elle n\'a pas d\'usage dans un navigateur.',
    licenseErrorTitle: 'Licence non validée',
    licenseErrorHint: 'La licence Waypoint360 n\'a pas pu être vérifiée sur cet appareil.',
    connectErrorTitle: 'Connexion impossible',
    connecting: 'Connexion à Waypoint360…',
  },
  errors: {
    apiModuleLoad: 'Échec du chargement du module API.',
    authRejected: 'Authentification refusée.',
    unknown: 'Erreur inconnue.',
    remoteDataUnavailable: 'Donnée indisponible, veuillez redémarrer la radiocommande.',
  },
  home: {
    logout: 'Déconnexion',
    collecting: 'Collecte active',
    connecting: 'Connexion…',
    exit: 'Quitter',
    cancel: 'Annuler',
    exitConfirm: 'Après avoir quitté, les données ne seront plus synchronisées entre DJI Pilot et Waypoint360.',
    serialNumbers: 'Numéros de série',
    remoteSn: 'SN radiocommande',
    droneSn: 'SN drone',
    settings: 'Réglages',
    droneBinding: 'Liaison du drone',
    bound: 'Drone lié',
    unbound: 'Drone non lié',
    mediaUpload: 'Envoi des médias',
  },
}
